<section
    class="advisor-controls padding-top-xs padding-left-l padding-bottom-xs padding-right-l"
>
    <ng-content></ng-content>
</section>
